import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, MedicineQuestionUsage, QuickSurveyAnswer} from "../stores/store_types"

const callMedicineQuestionAnalyticsAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, medicineQuestionUsageAllCount: number,
  medicineQuestionPregnantUsages: MedicineQuestionUsage,
  medicineQuestionAfterChildbirthUsages: MedicineQuestionUsage,
  medicineQuestionQuickSurveys: Array<QuickSurveyAnswer>) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/medicine_question_analytics",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["countOfUsages"]["allCount"], response.data["countOfUsages"]["pregnant"], response.data["countOfUsages"]["afterChildbirth"], response.data["countOfUsages"]["quickSurveys"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
export { callMedicineQuestionAnalyticsAPI }
